import { usePageContent } from "@/hooks/usePageContent";

const features = [
  {
    icon: "ri-shield-check-line",
    title: "Trusted & Transparent",
    desc: "Every listing is AI-verified with complete legal due diligence. No hidden fees, no surprises — just honest land monetization.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Fast Monetization",
    desc: "Go from land assessment to earning rental income in as little as 30 days. Our AI engine matches your parcel with the right partner instantly.",
  },
  {
    icon: "ri-team-line",
    title: "200+ Brand Partners",
    desc: "We work with India's top telecom, solar, warehousing, and retail brands who are actively seeking land — your property gets maximum visibility.",
  },
  {
    icon: "ri-funds-line",
    title: "Zero Upfront Cost",
    desc: "List your land completely free. You only pay a small success fee when a deal closes. No listing charges, no marketing fees, no risk.",
  },
];

export default function WhyChooseUsSection() {
  const { getContent } = usePageContent('homepage');
  const heading = getContent('home-whychoose-heading') || 'What Makes Us Different';

  return (
    <section className="py-24 bg-background-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-sm text-primary-500 font-medium uppercase tracking-wider mb-3">
            Why Choose Us
          </span>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground-950 mb-4">
            {heading}
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            We&apos;re not just a listing platform — we&apos;re India&apos;s first AI-powered land monetization
            engine that turns your idle property into a steady income stream.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {features.map((feature, i) => (
            <div
              key={i}
              className="group p-6 rounded-2xl card-dark hover:border-primary-500/40 transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-background-50 border border-primary-500/30 mx-auto mb-5 group-hover:border-primary-500/60 transition-colors">
                <i className={`${feature.icon} text-2xl text-primary-500`} />
              </div>
              <h3 className="font-display font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}